// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"566f7f27","796":"9164ceac"}[chunkId] + ".chunk.js";
};